/**
 * useSubSubtaskHandlers — UI event handlers for sub-subtask interactions.
 */
import { GoalOperations } from "../goal-state/useGoalEventHandlers";

export const useSubSubtaskHandlers = (operations: GoalOperations) => {
  const handleAddSubSubtask = (goalTitle: string, todoId: string, subtaskId: string, subSubtaskText: string) => {
    return operations.addSubSubtask({
      goalTitle,
      todoId,
      subtaskId,
      subSubtaskText
    });
  };

  const handleDeleteSubSubtask = (goalTitle: string, todoId: string, subtaskId: string, subSubtaskId: string) => {
    return operations.deleteSubSubtask({
      goalTitle,
      todoId,
      subtaskId,
      subSubtaskId
    });
  };

  const handleToggleSubSubtask = (goalTitle: string, todoId: string, subtaskId: string, subSubtaskId: string) => {
    return operations.toggleSubSubtask({
      goalTitle,
      todoId,
      subtaskId,
      subSubtaskId
    });
  };

  return {
    handleAddSubSubtask,
    handleDeleteSubSubtask,
    handleToggleSubSubtask
  };
};
